import { joinClasses } from '../Utils/className.util';
import styles from './OverlayLoading.module.scss';

export default function OverlayLoading({ className = null }) {
	return (
		<div className={styles.wrapper}>
			<div className={joinClasses(['sk-circle', className])}>
				{[...Array(12)].map((x, i) => (
					<div className={`sk-circle${i + 1} sk-child`} key={i} />
				))}
			</div>
		</div>
	);
}
